import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault } from '@/types/api.type';
import type {
  Channel,
  DeliveryStatus,
  NotificationType,
} from '../constants/notification-delivery-labels.constant';
import {
  toGetNotificationDeliveriesDTO,
  type GetNotificationDeliveriesDTO,
} from '../schemas/get-notification-deliveries.schema';

export type GetNotificationDeliveriesParams = Partial<ApiParamsDefault> & {
  channel?: Channel;
  status?: DeliveryStatus;
  notification_type?: NotificationType;
  /** ISO 8601 with local offset, start of the first selected day. */
  start_date?: string;
  /** ISO 8601 with local offset, end of the last selected day. */
  end_date?: string;
};

export const GET_NOTIFICATION_DELIVERIES_QUERY_KEY = 'notification-deliveries';

export const getNotificationDeliveries = async (
  params?: GetNotificationDeliveriesParams
): Promise<GetNotificationDeliveriesDTO> => {
  const response = await apiClient.get('notification-delivery', { params });

  return toGetNotificationDeliveriesDTO(response);
};
